import { Show } from '@/components/show'
import type { GroupInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { Children } from 'react'
import { Separator } from '@/components/ui/separator'

export default function GroupInput({
  children,
  depth = 0,
  label,
  labelComponent
}: GroupInputProps) {
  const HeadingComponent = `h${depth + 1}` as 'h1'

  if (depth === 1) {
    return (
      <>
        <Show when={labelComponent || label}>
          <HeadingComponent className='text-base font-semibold'>
            {labelComponent ?? label}
          </HeadingComponent>
        </Show>
        {children}
      </>
    )
  }

  if (depth > 1) {
    return (
      <>
        <Show when={labelComponent || label}>
          <HeadingComponent className='text-sm font-medium'>
            {labelComponent ?? label}
          </HeadingComponent>
        </Show>
        <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
          {children}
        </div>
      </>
    )
  }

  return (
    <Show when={Children.count(children) > 0}>
      <Show when={labelComponent || label}>
        <HeadingComponent className=''>
          {labelComponent ?? label}
        </HeadingComponent>
        <div>
          <Separator />
        </div>
      </Show>
      <div className='space-y-4'>{children}</div>
    </Show>
  )
}
